let jobs: TrackedExtractionObservationJob[] = [];
const changeListeners = new Set<() => void>();

export interface TrackedExtractionObservationJob {
    jobId: string;
    invoiceId: string;
    startedAt: number;
}

function emitChange() {
    changeListeners.forEach((listener) => listener());
}

export function trackExtractionObservationJob(job: Omit<TrackedExtractionObservationJob, 'startedAt'> & { startedAt?: number }) {
    const next: TrackedExtractionObservationJob = { ...job, startedAt: job.startedAt ?? Date.now() };
    jobs = [...jobs.filter((existing) => existing.jobId !== next.jobId), next];
    emitChange();
}

export function listExtractionObservationJobs(): TrackedExtractionObservationJob[] {
    return jobs;
}

export function finishExtractionObservationJob(jobId: string) {
    jobs = jobs.filter((job) => job.jobId !== jobId);
    emitChange();
}

export function subscribeExtractionObservationJobs(listener: () => void): () => void {
    changeListeners.add(listener);
    return () => changeListeners.delete(listener);
}
